<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.438 11.6622L12.248 20.8522C11.1221 21.9781 9.59515 22.6106 8.00297 22.6106C6.41079 22.6106 4.88381 21.9781 3.75797 20.8522C2.63213 19.7264 1.99963 18.1994 1.99963 16.6072C1.99963 15.015 2.63213 13.4881 3.75797 12.3622L12.948 3.17222C13.6985 2.42166 14.7165 2 15.778 2C16.8394 2 17.8574 2.42166 18.608 3.17222C19.3585 3.92279 19.7802 4.94077 19.7802 6.00222C19.7802 7.06368 19.3585 8.08166 18.608 8.83222L9.40797 18.0222C9.22215 18.208 9.00155 18.3554 8.75876 18.456C8.51598 18.5566 8.25576 18.6083 7.99297 18.6083C7.73018 18.6083 7.46996 18.5566 7.22718 18.456C6.98439 18.3554 6.76379 18.208 6.57797 18.0222C6.39215 17.8364 6.24475 17.6158 6.14418 17.373C6.04362 17.1302 5.99186 16.87 5.99186 16.6072C5.99186 16.3444 6.04362 16.0842 6.14418 15.8414C6.24475 15.5986 6.39215 15.378 6.57797 15.1922L15.068 6.71222"
      stroke="var(--svg-col, #261F4D)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
